import { render, staticRenderFns } from "./memberPermissions.vue?vue&type=template&id=9c9edeb4"
import script from "./memberPermissions.vue?vue&type=script&lang=js"
export * from "./memberPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports